import { CURRENT_ENV } from '@root/core/configs/env';
import { Button, Card, Form, Input, message, Modal, Row, Spin } from 'antd';
import React, { useState } from 'react';

import forgotPassService from '@root/modules/Authentication/ForgotPass/services/forgotpass';
import { Link, useHistory } from 'react-router-dom';
import { useTypedSelector } from '@root/core/hooks/useTypedSelector';
import useTranslate from '@root/core/hooks/useTranslate';

/*---------------forgot pas------------------*/

const ForgotPass: React.FC = () => {
  const history = useHistory();
  const [t] = useTranslate();

  const [reset, setReset] = useState('');

  const [loading, setLoading] = useState(false);

  const { type } = useTypedSelector((state) => state.inventoryReducer);

  const [show, setShow] = useState(false);
  const [showWrong, setShowWrong] = useState(false);

  const handleRequest = async (value: any) => {
    if (type === 'forwarder-admin') {
      try {
        const getRequest = await forgotPassService.postResetForwarder({
          email: value.email
        });

        const { arr } = getRequest;
        setLoading(false);
        setShow(true);
      } catch (error: any) {
        const { response } = error;
        if (response && response.data) {
          setLoading(false);

          setShowWrong(true);
        }
      } finally {
        setLoading(false);
      }
    } else if (type === 'seller-admin') {
      setLoading(true);
      try {
        const getRequest = await forgotPassService.postResetSell({
          email: value.email
        });

        const { arr } = getRequest;
        setLoading(false);
        setShow(true);
      } catch (error: any) {
        const { response } = error;
        if (response && response.data) {
          setLoading(false);

          setShowWrong(true);
        }
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(true);
      console.log(value, 'HIHI');
      try {
        const getRequest = await forgotPassService.postReset({
          email: value.email
        });

        if (getRequest.message === 'success') {
          setLoading(false);
          setShow(true);
        }
      } catch (error: any) {
        const { response } = error;
        if (response && response.data) {
          setLoading(false);
          setShowWrong(true);
        }
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <>
      {}
      <Spin spinning={loading} className="loading-forgot">
        <div className="container login-page directSignup">
          <Form layout="vertical" onFinish={handleRequest}>
            {type !== 'warehouse-admin' ? (
              <>
                <Row justify="space-around" align="middle">
                  <div className="login-form">
                    <Card>
                      <div className="login-form__top">
                        <div className="wrapper-image">
                          <img
                            src={`${CURRENT_ENV.PREFIX_IMG}/images/logo-busk.svg`}
                            alt="logo-terafty"
                          />
                        </div>

                        <p>{t('seller:forgotpass')}</p>
                      </div>

                      <Form.Item
                        name="email"
                        label={t('common:email')}
                        rules={[
                          {
                            required: true,
                            message: t('seller:forgotpass:cant-blank')
                          }
                        ]}
                      >
                        <Input />
                      </Form.Item>
                      <Button type="primary" htmlType="submit" block={true}>
                        {t('common:send')}
                      </Button>
                    </Card>
                  </div>
                </Row>
              </>
            ) : (
              <>
                {' '}
                <Row justify="space-around" align="middle">
                  <div className="login-form">
                    <Card>
                      <div className="login-form__top">
                        <div className="wrapper-image">
                          <img
                            src={`${CURRENT_ENV.PREFIX_IMG}/images/logo-busk.svg`}
                            alt="logo-terafty"
                          />
                        </div>

                        <p>
                          Please enter the email you used to register below. We
                          will send you a password reset email.
                        </p>
                      </div>

                      <Form.Item
                        name="email"
                        label="Email"
                        rules={[
                          {
                            required: true,
                            message: 'Email should not be empty'
                          }
                        ]}
                      >
                        <Input />
                      </Form.Item>
                      <Button type="primary" htmlType="submit" block={true}>
                        Send
                      </Button>
                    </Card>
                  </div>
                </Row>
              </>
            )}
          </Form>
        </div>
      </Spin>{' '}
      <Modal
        width={400}
        visible={show}
        onOk={() => {
          {
            type === 'warehouse-admin'
              ? history.push('/admin/login-warehouse')
              : history.push('/admin/login');
          }

          setShow(false);
        }}
        cancelButtonProps={{ style: { display: 'none' } }}
        onCancel={() => {
          setShow(false);
        }}
        okButtonProps={{
          style: {
            padding: '.5rem 2.5rem',
            height: 'auto',
            border: 'none',
            borderRadius: '7.25px',
            backgroundColor: '#2B2C51',
            display: 'inline-block'
          }
        }}
        okText={type === 'warehouse-admin' ? 'OK' : '확인'}
        maskClosable={true}
      >
        {type === 'warehouse-admin' ? (
          <>
            {' '}
            <div>
              <strong>An email has been sent.</strong>
            </div>
            <div style={{ textAlign: 'center' }}>
              This password reset email is only valid for one hour after it is
              sent.
            </div>
          </>
        ) : (
          <>
            {' '}
            <div>
              <strong>{t('seller:forgotpass:message-success')}</strong>
            </div>
            <div style={{ textAlign: 'center' }}>
              {t('seller:forgotpass:message-content')}
            </div>
          </>
        )}
      </Modal>
      <Modal
        width={400}
        visible={showWrong}
        onOk={() => {
          setShowWrong(false);
        }}
        cancelButtonProps={{ style: { display: 'none' } }}
        onCancel={() => {
          setShow(false);
        }}
        okButtonProps={{
          style: {
            padding: '.5rem 2.5rem',
            height: 'auto',
            border: 'none',
            borderRadius: '7.25px',
            backgroundColor: '#2B2C51',
            display: 'inline-block'
          }
        }}
        okText={type === 'warehouse-admin' ? 'OK' : '확인'}
        maskClosable={true}
      >
        {type === 'warehouse-admin' ? (
          <>
            <div>
              <strong>There is no matching member information.</strong>
            </div>
            <div style={{ textAlign: 'center' }}>
              Please enter the email the correctly.
            </div>
          </>
        ) : (
          <>
            {' '}
            <div>
              <strong>{t('seller:forgotpass:error-match')}</strong>
            </div>
            <div style={{ textAlign: 'center' }}>
              {t('seller:forgotpass:error-content')}
            </div>
          </>
        )}
      </Modal>
      {type === 'warehouse-admin' ? (
        <p className="navigaSign">
          Don't you have an account?
          <Link to="/admin/sign-up">
            <span> Going to sign up</span>
          </Link>
        </p>
      ) : null}
    </>
  );
};

export default ForgotPass;
